import { useState } from 'react';
import type { IFinishReferralOffers } from '@alfa-bank/site-dc-form-api/src/models';

export const useReferral = (offers: IFinishReferralOffers) => {
    const [notificationVisible, setNotificationVisible] = useState(false);
    const handleOnClick = async () => {
        try {
            await navigator.clipboard.writeText(offers.clientPayload.shortLink);
            setNotificationVisible(true);
        } catch (error) {
            console.error(error);
        }
    };

    const handleShareClick = async () => {
        try {
            await navigator.share({ url: offers.clientPayload.shortLink });
        } catch (error) {
            console.error(error);
        }
    };

    return { handleOnClick, handleShareClick, notificationVisible, setNotificationVisible };
};
